module.exports = __webpack_public_path__ + "sounds/resources/sounds/echoed-ding-459.6d571d2ba06de8e80db431bbb2378c17.ogg";